import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
  UserIcon,
} from "../../../../components/icons/Icons";
import styles from "./EventOverview.module.css";
import brideImg from "../../../../assets/staticImages/bride.png";
import groomImg from "../../../../assets/staticImages/groom.png";



export const timeLeft = [
  { title: "Days", duration: "23" },
  { title: "Hrs", duration: "11" },
  { title: "Mins", duration: "59" },
];

export const calendarIcon = (
  <svg
    className={styles.inputIcon}
    viewBox="0 0 42 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.2795 4.46484H32.7266V1.83984C32.7266 1.11403 32.1538 0.527344 31.4453 0.527344C30.7368 0.527344 30.1641 1.11403 30.1641 1.83984V4.46484H22.4766V1.83984C22.4766 1.11403 21.9026 0.527344 21.1953 0.527344C20.4881 0.527344 19.9141 1.11403 19.9141 1.83984V4.46484H12.2266V1.83984C12.2266 1.11403 11.6526 0.527344 10.9453 0.527344C10.2381 0.527344 9.66406 1.11403 9.66406 1.83984V4.46484H4.11241C2.22512 4.46484 0.695312 6.03066 0.695312 7.96397V39.0269C0.695312 40.9602 2.22512 42.5273 4.11241 42.5273H38.2795C40.1668 42.5273 41.6953 40.9602 41.6953 39.0269V7.96397C41.6953 6.03066 40.1668 4.46484 38.2795 4.46484ZM39.1328 39.0269C39.1328 39.5099 38.7497 39.9023 38.2795 39.9023H4.11241C3.64091 39.9023 3.25781 39.5099 3.25781 39.0269V7.96397C3.25781 7.48228 3.64091 7.08984 4.11241 7.08984H9.66406V9.71484C9.66406 10.4407 10.2381 11.0273 10.9453 11.0273C11.6526 11.0273 12.2266 10.4407 12.2266 9.71484V7.08984H19.9141V9.71484C19.9141 10.4407 20.4881 11.0273 21.1953 11.0273C21.9026 11.0273 22.4766 10.4407 22.4766 9.71484V7.08984H30.1641V9.71484C30.1641 10.4407 30.7368 11.0273 31.4453 11.0273C32.1538 11.0273 32.7266 10.4407 32.7266 9.71484V7.08984H38.2795C38.7497 7.08984 39.1328 7.48228 39.1328 7.96397V39.0269Z"
      className={styles.inputIconPath}
    />
    <path
      d="M14.7891 16.2773H9.66406V20.2148H14.7891V16.2773Z"
      className={styles.inputIconPath}
    />
    <path
      d="M14.7891 22.8398H9.66406V26.7773H14.7891V22.8398Z"
      className={styles.inputIconPath}
    />
    <path
      d="M14.7891 29.4023H9.66406V33.3398H14.7891V29.4023Z"
      className={styles.inputIconPath}
    />
    <path
      d="M23.7578 29.4023H18.6328V33.3398H23.7578V29.4023Z"
      className={styles.inputIconPath}
    />
    <path
      d="M23.7578 22.8398H18.6328V26.7773H23.7578V22.8398Z"
      className={styles.inputIconPath}
    />
    <path
      d="M23.7578 16.2773H18.6328V20.2148H23.7578V16.2773Z"
      className={styles.inputIconPath}
    />
    <path
      d="M32.7266 29.4023H27.6016V33.3398H32.7266V29.4023Z"
      className={styles.inputIconPath}
    />
    <path
      d="M32.7266 22.8398H27.6016V26.7773H32.7266V22.8398Z"
      className={styles.inputIconPath}
    />
    <path
      d="M32.7266 16.2773H27.6016V20.2148H32.7266V16.2773Z"
      className={styles.inputIconPath}
    />
  </svg>
);

export const timeIcon = (
  <svg
    className={styles.inputIcon}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1356 37.49C14.2812 37.49 9.62561 35.5616 6.19303 32.129C2.76044 28.6964 0.832031 24.0408 0.832031 19.1864C0.832031 14.332 2.76044 9.67639 6.19303 6.24381C9.62561 2.81122 14.2812 0.882813 19.1356 0.882812C23.99 0.882812 28.6456 2.81122 32.0782 6.24381C35.5108 9.67639 37.4392 14.332 37.4392 19.1864C37.4392 24.0408 35.5108 28.6964 32.0782 32.129C28.6456 35.5616 23.99 37.49 19.1356 37.49ZM19.1356 33.8293C23.0191 33.8293 26.7436 32.2865 29.4897 29.5405C32.2358 26.7944 33.7785 23.0699 33.7785 19.1864C33.7785 15.3029 32.2358 11.5784 29.4897 8.83232C26.7436 6.08626 23.0191 4.54353 19.1356 4.54353C15.2521 4.54353 11.5276 6.08626 8.78154 8.83232C6.03547 11.5784 4.49275 15.3029 4.49275 19.1864C4.49275 23.0699 6.03547 26.7944 8.78154 29.5405C11.5276 32.2865 15.2521 33.8293 19.1356 33.8293ZM17.3053 19.9368V8.20425H20.966V18.4359L28.1959 25.6659L25.6151 28.2467L17.3053 19.9368Z"
      className={styles.inputIconPath}
    />
  </svg>
);

export const addressIcon = (
  <svg
    className={styles.inputIcon}
    viewBox="0 0 37 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8426 24.339C14.3498 25.8462 16.3939 26.6929 18.5254 26.6929C19.5808 26.6929 20.6258 26.4851 21.6009 26.0812C22.576 25.6773 23.4619 25.0853 24.2082 24.339C24.9545 23.5928 25.5464 22.7068 25.9503 21.7318C26.3542 20.7567 26.5621 19.7116 26.5621 18.6562C26.5621 16.5248 25.7154 14.4806 24.2082 12.9735C22.701 11.4663 20.6569 10.6196 18.5254 10.6196C16.3939 10.6196 14.3498 11.4663 12.8426 12.9734C11.3354 14.4806 10.4887 16.5248 10.4887 18.6562C10.4887 20.7877 11.3354 22.8319 12.8426 24.339ZM18.5254 50.3618C18.0703 49.8273 17.4938 49.1387 16.8303 48.3211C15.1337 46.2307 12.8741 43.305 10.6175 39.9603C8.35795 36.6114 6.11993 32.8696 4.45136 29.1451C2.77399 25.401 1.72266 21.7845 1.72266 18.6562C1.72266 14.1999 3.49294 9.92605 6.64406 6.77492C9.79519 3.6238 14.069 1.85352 18.5254 1.85352C22.9818 1.85352 27.2556 3.6238 30.4067 6.77492C33.5578 9.92605 35.3281 14.1999 35.3281 18.6562C35.3281 21.7845 34.2768 25.401 32.5994 29.1451C30.9308 32.8696 28.6928 36.6114 26.4333 39.9603C24.1767 43.305 21.9171 46.2307 20.2205 48.3211C19.5569 49.1387 18.9805 49.8273 18.5254 50.3618Z"
      className={styles.inputIconPathOutline}
    />
  </svg>
);

export const editIcon = (
  <svg
    className={styles.btnSvg}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_58_4525)">
      <path
        d="M25.0467 11.5412C24.7016 11.5412 24.3706 11.6814 24.1265 11.931C23.8825 12.1806 23.7454 12.5191 23.7454 12.872V20.7907C23.7433 21.496 23.4685 22.1718 22.9808 22.6705C22.4932 23.1692 21.8324 23.4503 21.1428 23.4524H10.7325C10.0429 23.4503 9.38211 23.1692 8.89447 22.6705C8.40684 22.1718 8.13198 21.496 8.12992 20.7907V10.1438C8.13198 9.43848 8.40684 8.76268 8.89447 8.26397C9.38211 7.76525 10.0429 7.48415 10.7325 7.48204H18.4752C18.8203 7.48204 19.1513 7.34182 19.3953 7.09224C19.6394 6.84265 19.7765 6.50414 19.7765 6.15118C19.7765 5.79821 19.6394 5.4597 19.3953 5.21011C19.1513 4.96053 18.8203 4.82031 18.4752 4.82031H10.7325C9.35327 4.82453 8.03171 5.38674 7.05645 6.38417C6.08118 7.3816 5.53146 8.7332 5.52734 10.1438V20.7907C5.53146 22.2012 6.08118 23.5528 7.05645 24.5503C8.03171 25.5477 9.35327 26.1099 10.7325 26.1141H21.1428C22.522 26.1099 23.8436 25.5477 24.8189 24.5503C25.7941 23.5528 26.3439 22.2012 26.348 20.7907V12.872C26.348 12.5191 26.2109 12.1806 25.9668 11.931C25.7228 11.6814 25.3918 11.5412 25.0467 11.5412ZM15.0268 16.7315C15.1443 16.8576 15.2856 16.958 15.4422 17.0266C15.5988 17.0952 15.7673 17.1306 15.9377 17.1306C16.108 17.1306 16.2766 17.0952 16.4331 17.0266C16.5897 16.958 16.731 16.8576 16.8486 16.7315L24.331 9.07908C24.5685 8.83115 24.7008 8.49736 24.6991 8.15023C24.6974 7.8031 24.5618 7.47069 24.3218 7.22523C24.0818 6.97977 23.7568 6.8411 23.4174 6.83934C23.078 6.83759 22.7516 6.9729 22.5092 7.21587L15.0268 14.8683C14.9035 14.9885 14.8053 15.1331 14.7382 15.2932C14.6711 15.4533 14.6366 15.6257 14.6366 15.7999C14.6366 15.9741 14.6711 16.1465 14.7382 16.3067C14.8053 16.4668 14.9035 16.6114 15.0268 16.7315Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_58_4525">
        <rect
          width="25"
          height="25"
          fill="white"
          transform="translate(0.824219 0.623047)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const timeIconWhite = (
  <svg
    className={styles.btnSvg}
    viewBox="0 0 23 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2188 8.21094V13.9252M21.2188 14.2109C21.2188 19.7309 16.7388 24.2109 11.2188 24.2109C5.69875 24.2109 1.21875 19.7309 1.21875 14.2109C1.21875 8.69094 5.69875 4.21094 11.2188 4.21094C16.7388 4.21094 21.2188 8.69094 21.2188 14.2109Z"
      stroke="white"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.78906 1.35352H14.6462"
      stroke="white"
      stroke-width="2.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const pin = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 18.9597C24.0115 19.9051 23.8319 20.8431 23.472 21.7174C23.1121 22.5918 22.5792 23.3843 21.9054 24.0476C19.5172 26.4453 17.1386 28.853 14.7379 31.2382C12.4043 33.5568 9.18899 34.1519 6.30735 32.5663C3.72579 31.146 1.62317 29.1496 0.76048 26.1883C0.366782 24.9785 0.319395 23.6826 0.62368 22.4472C0.927965 21.2119 1.57178 20.0862 2.48235 19.1976C3.25286 18.387 4.04541 17.5945 4.85099 16.821C5.7247 15.9798 6.82586 15.9593 7.60638 16.7353C7.79242 16.9164 7.93922 17.1339 8.03766 17.3741C8.13611 17.6144 8.18409 17.8723 8.17864 18.1319C8.17319 18.3915 8.11442 18.6472 8.00598 18.8831C7.89754 19.119 7.74174 19.3301 7.54827 19.5032C6.81934 20.2742 6.06086 21.0172 5.30639 21.7632C4.34049 22.7185 3.93921 23.8978 4.43067 25.1443C4.79081 26.1582 5.38004 27.0753 6.15251 27.8243C6.92498 28.5734 7.85986 29.134 8.88439 29.4627C9.40769 29.6348 9.9695 29.6525 10.5026 29.5136C11.0357 29.3748 11.5175 29.0852 11.8903 28.6797C14.3771 26.2189 16.855 23.748 19.2963 21.2411C20.5567 19.9466 20.4906 18.0143 19.2266 16.4638C18.9184 16.1634 18.6737 15.8041 18.5072 15.4072C18.378 14.9926 18.3925 14.5464 18.5483 14.141C18.7042 13.7356 18.9922 13.3947 19.3659 13.1733C19.7352 12.9429 20.1746 12.8519 20.605 12.917C21.0354 12.982 21.4284 13.1987 21.713 13.528C23.1539 14.9715 23.9745 16.9203 24 18.9597Z"
      fill="black"
    />
    <path
      d="M9.88676 14.5974C9.88111 12.8015 10.5858 11.0763 11.8471 9.79796C14.3445 7.26751 16.8294 4.72352 19.3809 2.24868C20.2886 1.29282 21.465 0.634912 22.7546 0.361909C24.0442 0.0889062 25.3863 0.213663 26.6035 0.719681C28.1647 1.27235 29.5726 2.18748 30.7115 3.38992C31.8503 4.59236 32.6877 6.0478 33.1548 7.63672C33.5234 8.79473 33.5688 10.0314 33.2863 11.2133C33.0038 12.3953 32.4041 13.4777 31.5517 14.3439C30.956 15.0026 30.3223 15.6289 29.675 16.2371C29.5045 16.4224 29.2984 16.5713 29.0689 16.675C28.8395 16.7787 28.5915 16.8351 28.3397 16.8406C28.088 16.8461 27.8377 16.8007 27.6039 16.7072C27.3702 16.6136 27.1577 16.4738 26.9792 16.2962C26.7912 16.1174 26.642 15.9019 26.5407 15.6631C26.4394 15.4242 26.3882 15.1671 26.3904 14.9077C26.3925 14.6483 26.448 14.3921 26.5532 14.155C26.6585 13.9178 26.8113 13.7049 27.0023 13.5293C27.5093 12.9832 28.0468 12.4652 28.5769 11.9417C29.5413 10.9898 29.9501 9.80898 29.4581 8.56254C29.0986 7.53332 28.5015 6.60335 27.7154 5.84807C26.9292 5.09279 25.976 4.53349 24.9332 4.21553C24.4209 4.05829 23.8746 4.04917 23.3573 4.18924C22.8401 4.3293 22.373 4.61283 22.01 5.00708C19.5248 7.46823 17.0566 9.94659 14.6055 12.4421C13.3425 13.7342 13.3911 15.673 14.6506 17.2155C14.9811 17.5338 15.2362 17.922 15.3971 18.3517C15.5096 18.7551 15.4873 19.1842 15.3336 19.5738C15.1798 19.9634 14.9031 20.2921 14.5454 20.5099C14.1799 20.7469 13.7413 20.8443 13.3098 20.7844C12.8784 20.7246 12.4829 20.5113 12.1958 20.1838C11.4608 19.4515 10.8783 18.5807 10.4819 17.6218C10.0856 16.6629 9.88332 15.6349 9.88676 14.5974Z"
      fill="black"
    />
  </svg>
);

export const details = [
  {
    title: "Date:",
    icon: <CalendarIcon size={30} />,
    value: "Feb 9, 2023",
  },
  { title: "Start Time:", icon: <ClockIcon size={30} />, value: "10:15 am" },
  { title: "End Time:", icon: <ClockIcon size={30} />, value: "02:15 pm" },
  { title: "Guests:", icon: <UserIcon size={30} />, value: "04/24" },
  {
    title: "Location:",
    icon: <LocIcon size={30} />,
    value: "Los Angeles, California",
  },
  { title: "Event:", icon: <UserIcon size={30} />, value: "Wedding" },
];

export const viewBtnIcon = (
  <svg
    className={styles.viewBtnIcon}
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1636_528)">
      <path
        d="M12.1938 0.637016C19.1003 0.594686 24.497 5.07801 25.5555 11.0748C25.8186 12.5661 25.8344 14.0491 25.5637 15.5396C25.5187 15.7869 25.4288 15.8678 25.1792 15.8619C24.53 15.8463 23.88 15.847 23.2308 15.8604C22.9647 15.8656 22.8987 15.8106 22.9527 15.5262C23.7076 11.5464 22.6011 8.16813 19.4931 5.51988C15.2171 1.87574 8.45154 2.57085 4.97093 6.9606C0.951324 12.0313 2.44537 19.2201 8.16593 22.2939C9.54977 23.0373 11.0438 23.4116 12.6158 23.4561C12.9059 23.4643 12.9667 23.5594 12.9584 23.8237C12.9397 24.4171 12.9337 25.0127 12.9607 25.6053C12.9749 25.9291 12.8909 26.0272 12.5514 26.0123C9.62024 25.8831 6.98748 24.9459 4.76028 23.0551C1.32015 20.1358 -0.235367 16.3892 0.239909 11.9318C0.661211 7.9795 2.64328 4.88566 5.9972 2.68373C8.1037 1.29945 10.4434 0.655582 12.1938 0.637016Z"
        fill="white"
      />
      <path
        d="M22.0805 19.6765C23.3474 19.6772 24.5445 20.1941 25.6495 20.9605C26.5963 21.6177 27.4112 22.4168 28.1578 23.2865C28.2351 23.3763 28.3423 23.4469 28.2148 23.5924C26.9951 24.9893 25.669 26.2511 23.8789 26.912C22.0167 27.599 20.2723 27.2744 18.6208 26.2652C17.4716 25.5627 16.5248 24.6336 15.6477 23.6288C15.5495 23.5167 15.5323 23.4402 15.6402 23.3177C16.731 22.0789 17.9147 20.9575 19.4357 20.2387C20.2356 19.8607 21.0984 19.6624 22.0805 19.6765ZM20.6389 23.4424C20.6224 24.1353 21.1989 24.7316 21.8968 24.7458C22.5835 24.7591 23.1907 24.1687 23.1997 23.4803C23.2079 22.8037 22.6412 22.2237 21.9538 22.2052C21.2469 22.1859 20.6546 22.7428 20.6389 23.4424Z"
        fill="white"
      />
      <path
        d="M11.6694 10.1648C11.6694 8.79166 11.6754 7.41777 11.6641 6.04463C11.6619 5.79436 11.7226 5.69485 11.994 5.70227C12.6304 5.71935 13.2676 5.71861 13.9048 5.70153C14.1687 5.69485 14.2414 5.78099 14.2399 6.03795C14.2302 7.90643 14.2422 9.77417 14.2272 11.6427C14.2249 11.9635 14.2984 12.0615 14.638 12.0585C16.5113 12.0407 18.3847 12.0556 20.2581 12.0452C20.5414 12.0437 20.6531 12.1068 20.6419 12.4098C20.6194 13.0403 20.6269 13.6715 20.6396 14.3028C20.6441 14.5308 20.5692 14.5976 20.3398 14.5969C17.5548 14.5902 14.7699 14.5887 11.985 14.5984C11.7009 14.5991 11.6649 14.4847 11.6671 14.2478C11.6739 12.8866 11.6694 11.5253 11.6694 10.1648Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1636_528">
        <rect
          width="28.12"
          height="26.64"
          fill="white"
          transform="translate(0.15625 0.636719)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const personArr = [
  {
    title: "Bride",
    name: "Lucy Mark",
    img: brideImg,
    contact: "+1 (234) 456-4567",
  },
  {
    title: "Groom",
    name: "David Elson",
    img: groomImg,
    contact: "+1 (234) 456-4567",
  },
];
